import React, {Component, Fragment} from 'react';
import {withTranslation} from "react-i18next";
import {route} from "../../../routes";
import config from "../../../config";
import i18n from "../../../i18n";
import {GelContentContainer, ResultsCounter} from "cw-styleguide-react";
import Helmet from 'react-helmet';

class ArticlesLandingView extends Component {
  render() {
    return (
      <Fragment>

        <Helmet>
          <title>{this.props.t('articles_title')} | {this.props.t('route_app_title')}</title>
        </Helmet>
        <GelContentContainer>
          <h1>{this.props.t('articles_title')}</h1>
          <p>{this.props.t('articles_introduction')}</p>
          <ResultsCounter count={this.props.articles.length}>
            {this.props.t('results')}
          </ResultsCounter>
          <ul className="style--columns-3 style--list-plain style--list-large">
            {this.props.articles.map((article, index) => {
              return (
                <li key={index}>
                  <a className={'anchor-list__link gel-md-mb-20'}
                     href={config.basePath[i18n.language] + route("articles") +  route('article', {article: article.slug})}>
                    {article.name}
                  </a>
                </li>
              );
            })}
          </ul>
        </GelContentContainer>
      </Fragment>
    );
  }
}

export default withTranslation('local')(ArticlesLandingView);
